import { type ReactNode } from "react";

import { BentoBoxPlaceholder } from "@react/sections/BentoBox/BentoBoxPlaceholder.view";
import { CollectionPlaceholder } from "@react/sections/Collection/CollectionPlaceholder.view";
import { ProductHeroPlaceholder } from "@react/sections/ProductHero/ProductHeroPlaceholder.view";
import {
  type CollectionSectionSettings,
  type ProductHeroSettings,
} from "@root/tablescape/state";
import { type BentoBoxSectionSettings } from "@root/tablescape/state/bentoBox";

export const resolveZonePlaceholder = (
  componentName: string,
  data?: Record<string, unknown>
): ReactNode => {
  switch (componentName) {
    case "BentoBox": {
      const section = data as BentoBoxSectionSettings;
      return <BentoBoxPlaceholder {...section} />;
    }

    case "CollectionProvider": {
      const section = data as CollectionSectionSettings;

      const {
        collectionHero: { heroImage },
        pagination: { pageSize },
        settings: { version },
      } = section ?? {};

      if (version !== "v2") {
        return null;
      }

      return (
        <CollectionPlaceholder
          pageSize={pageSize}
          showHeroImage={!!heroImage}
        />
      );
    }

    case "ProductHeroRoot": {
      const section = data as ProductHeroSettings;

      const {
        crossProductBridgeOptionsCount,
        productOptionCategoriesCount,
        productSelectorExperience,
        showCrossProductBridge,
        theme,
      } = section?.settings ?? {};

      const { lcpMedia } = section?.productGalleryCarousel ?? {};

      return (
        <ProductHeroPlaceholder
          animateIn
          crossProductBridgeOptionsCount={crossProductBridgeOptionsCount}
          lcpMedia={lcpMedia}
          productOptionCategoriesCount={productOptionCategoriesCount}
          productSelectorExperience={productSelectorExperience}
          region="zone"
          showCrossProductBridge={showCrossProductBridge}
          theme={theme}
        />
      );
    }

    default:
      return (
        <div className="placeholder animate-fade-in">
          <div className="m-1.5 box-border">
            <div className="box-border h-10 w-full animate-pulse rounded bg-placeholder md:h-14"></div>
          </div>
        </div>
      );
  }
};
